import { render, staticRenderFns } from "./ShoppingListToggleButtonV2.vue?vue&type=template&id=425f08e7&scoped=true"
import script from "./ShoppingListToggleButtonV2.vue?vue&type=script&lang=js"
export * from "./ShoppingListToggleButtonV2.vue?vue&type=script&lang=js"
import style0 from "./ShoppingListToggleButtonV2.vue?vue&type=style&index=0&id=425f08e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f08e7",
  null
  
)

export default component.exports